/** Explicit bounds invariant at the algorithm boundary, including strict indexed access. */
export function valueAt(values: readonly number[], index: number): number {
  const value = values[index];
  if (value === undefined) throw new RangeError(`Invalid algorithm index ${index}`);
  return value;
}
